namespace $.$$ {
	const { rem } = $mol_style_unit
	$mol_style_define( $shm_showcase_component, {
		flex: { basis: rem( 40 ), grow: 1, shrink: 0 },
	} )
}
